export class CdKeyReassignRequest {

    Key: string;
    Name: string;
    NotifyEmail: string;

}